import { getCookie } from 'utils/cookies'

import { cookieKey, Layout } from '../containers/App/NewLayout/constant'

export const LAYOUT_FROM_COOKIE = getCookie(cookieKey) as Layout
export const IS_NEW_LAYOUT = LAYOUT_FROM_COOKIE === Layout.NEW
